export default {
    updateDebtor: { 
        url: 'updateDebtor', 
        method: 'post', 
    },
    updateDebtorPassword: { 
        url: 'updatePromoCode', 
        method: 'post', 
    }
}